var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3365 9.66203V18.0003C18.3365 19.5983 17.0571 20.8937 15.4789 20.8937H9.00196C7.42381 20.8937 6.14445 19.5983 6.14445 18.0003V9.66203M10.6173 13.037V17.3651M13.8625 13.037V17.3651M15.084 4.45711L15.8695 6.17051H18.4033C19.1823 6.17051 19.8139 6.80207 19.8139 7.58115V8.62582C19.8139 9.15849 19.3821 9.5903 18.8495 9.5903H5.63049C5.09782 9.5903 4.66602 9.15849 4.66602 8.62582V7.58115C4.66602 6.80207 5.29758 6.17051 6.07667 6.17051H8.61051L9.39598 4.45711C9.63166 3.94294 10.1455 3.61328 10.7111 3.61328H13.7689C14.3345 3.61328 14.8482 3.94294 15.084 4.45711Z",
    stroke: "#CC4C46",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9c3be1ff68fc3f1b72321d1549746b1b.svg";
export { ForwardRef as ReactComponent };